"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5 8a10.46 10.46 0 00-6.9 2.6L2 7v9h9l-3.62-3.62A8 8 0 0120.1 16l2.37-.78A10.51 10.51 0 0012.5 8z",
    fill: "inherit"
  }));
};

var _default = SvgUndo;
exports["default"] = _default;